export const MusicOn = () => (
  <svg
    id="Group_92"
    data-name="Group 92"
    xmlns="http://www.w3.org/2000/svg"
    width="17.199"
    height="27.504"
    viewBox="0 0 17.199 27.504"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1155"
          data-name="Rectangle 1155"
          width="17.199"
          height="27.504"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      id="Group_91"
      data-name="Group 91"
      transform="translate(0 0)"
      clip-path="url(#clip-path)"
    >
      <path
        id="Path_250"
        data-name="Path 250"
        d="M15.185,27.17,8.708,20.635H8.6V6.85h.108L15.185.319q.807-.807,2.014.43V26.765Q15.992,28,15.185,27.17M0,18.915V8.57A1.675,1.675,0,0,1,.5,7.36,1.64,1.64,0,0,1,1.72,6.85H6.88V20.635H1.72A1.636,1.636,0,0,1,.5,20.124,1.674,1.674,0,0,1,0,18.915"
        transform="translate(0 0)"
        fill="#fff"
      />
    </g>
  </svg>
);

export const ArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.583"
    height="11.931"
    viewBox="0 0 14.583 11.931"
  >
    <path
      id="Path_247"
      data-name="Path 247"
      d="M7.954,0V3.977H0V7.954H7.954v3.977H9.28V10.606h1.326V9.28h1.326V7.954h1.326V6.629h1.326V5.3H13.257V3.977H11.931V2.651H10.606V1.326H9.28V0Z"
      transform="translate(14.583 11.931) rotate(180)"
      fill="#7b6c75"
    />
  </svg>
);

export const CloseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.469"
    height="24.469"
    viewBox="0 0 24.469 24.469"
  >
    <path
      id="Path_253"
      data-name="Path 253"
      d="M24.981,23.715a1.907,1.907,0,0,1-.577,1.4l-2.8,2.8a1.989,1.989,0,0,1-2.8,0l-6.055-6.055L6.691,27.917a1.907,1.907,0,0,1-1.4.577,1.907,1.907,0,0,1-1.4-.577l-2.8-2.8a1.989,1.989,0,0,1,0-2.8l6.055-6.055L1.089,10.2a1.989,1.989,0,0,1,0-2.8l2.8-2.8a1.907,1.907,0,0,1,1.4-.577,1.907,1.907,0,0,1,1.4.577l6.055,6.055L18.8,4.6a1.989,1.989,0,0,1,2.8,0l2.8,2.8a1.989,1.989,0,0,1,0,2.8l-6.055,6.055L24.4,22.315A1.907,1.907,0,0,1,24.981,23.715Z"
      transform="translate(-0.512 -4.025)"
      fill="#fff"
    />
  </svg>
);

export const Pacman = () => (
  <svg
    id="Group_17"
    data-name="Group 17"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="132"
    height="14.164"
    viewBox="0 0 132 14.164"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_97"
          data-name="Rectangle 97"
          width="132"
          height="14.164"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      id="Group_16"
      data-name="Group 16"
      transform="translate(0 0)"
      clip-path="url(#clip-path)"
    >
      <path
        id="Path_44"
        data-name="Path 44"
        d="M169.444,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-148.256 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_45"
        data-name="Path 45"
        d="M84.722,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-74.128 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_46"
        data-name="Path 46"
        d="M0,43.957a1.812,1.812,0,1,1,1.812,1.812A1.812,1.812,0,0,1,0,43.957"
        transform="translate(0 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_47"
        data-name="Path 47"
        d="M847.219,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-741.277 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_48"
        data-name="Path 48"
        d="M762.5,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-667.15 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_49"
        data-name="Path 49"
        d="M677.776,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-593.022 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_50"
        data-name="Path 50"
        d="M593.054,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-518.895 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_51"
        data-name="Path 51"
        d="M508.332,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-444.767 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_52"
        data-name="Path 52"
        d="M423.61,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-370.639 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_53"
        data-name="Path 53"
        d="M338.888,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-296.511 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_54"
        data-name="Path 54"
        d="M254.166,43.957a1.812,1.812,0,1,1,1.812,1.812,1.812,1.812,0,0,1-1.812-1.812"
        transform="translate(-222.383 -36.875)"
        fill="#fff"
      />
      <path
        id="Path_55"
        data-name="Path 55"
        d="M961.972,7.081l-4.66-5.331a7.082,7.082,0,1,1-.627,10.043Z"
        transform="translate(-837.055 0)"
        fill="#ffde00"
      />
    </g>
  </svg>
);

export const BuyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.319"
    height="17.231"
    viewBox="0 0 18.319 17.231"
  >
    <g id="arrow-90deg-left" transform="translate(1.002 19.229) rotate(-90)">
      <g
        id="Group_696"
        data-name="Group 696"
        transform="translate(2.997 -0.002)"
      >
        <path
          id="Path_446"
          data-name="Path 446"
          d="M3.157,5.279a.544.544,0,0,1,0-.77L7.509.158a.545.545,0,1,1,.77.77L4.855,4.35H15.509a2.72,2.72,0,0,1,2.72,2.72v8.7a.544.544,0,1,1-1.088,0V7.07a1.632,1.632,0,0,0-1.632-1.632H4.855L8.279,8.861a.545.545,0,0,1-.77.77Z"
          transform="translate(-2.997 0.002)"
          fill="#49b7ab"
          stroke="#49b7ab"
          stroke-width="2"
          fill-rule="evenodd"
        />
      </g>
    </g>
  </svg>
);

export const SellIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.319"
    height="17.231"
    viewBox="0 0 18.319 17.231"
  >
    <g id="arrow-90deg-left" transform="translate(17.317 -1.997) rotate(90)">
      <g
        id="Group_696"
        data-name="Group 696"
        transform="translate(2.997 -0.002)"
      >
        <path
          id="Path_446"
          data-name="Path 446"
          d="M3.157,5.279a.544.544,0,0,1,0-.77L7.509.158a.545.545,0,1,1,.77.77L4.855,4.35H15.509a2.72,2.72,0,0,1,2.72,2.72v8.7a.544.544,0,1,1-1.088,0V7.07a1.632,1.632,0,0,0-1.632-1.632H4.855L8.279,8.861a.545.545,0,0,1-.77.77Z"
          transform="translate(-2.997 0.002)"
          fill="#e1007f"
          stroke="#e1007f"
          stroke-width="2"
          fill-rule="evenodd"
        />
      </g>
    </g>
  </svg>
);

export const Arrow = ({ fill = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.434"
    height="8.876"
    viewBox="0 0 15.434 8.876"
  >
    <g
      id="arrow-down-bold"
      transform="translate(19.464 23.878) rotate(180)"
      opacity="0.51"
    >
      <path
        id="Path_400"
        data-name="Path 400"
        d="M4.369,15.341a1.159,1.159,0,0,1,1.639,0l5.738,5.738,5.738-5.738a1.159,1.159,0,1,1,1.639,1.639l-6.558,6.558a1.159,1.159,0,0,1-1.639,0L4.369,16.98a1.159,1.159,0,0,1,0-1.639Z"
        transform="translate(0)"
        fill={fill}
      />
    </g>
  </svg>
);

export const LinkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.988"
    height="12.988"
    viewBox="0 0 12.988 12.988"
  >
    <g id="android-open" transform="translate(-6 -6)">
      <path
        id="Path_447"
        data-name="Path 447"
        d="M17.545,17.545H7.443V7.443h4.51V6H7.443A1.447,1.447,0,0,0,6,7.443v10.1a1.447,1.447,0,0,0,1.443,1.443h10.1a1.447,1.447,0,0,0,1.443-1.443v-4.51H17.545ZM13.576,6V7.443h2.959L9.247,14.731l1.01,1.01,7.288-7.288v2.959h1.443V6Z"
        fill="#c67ba6"
      />
    </g>
  </svg>
);

export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.92"
    height="10.92"
    viewBox="0 0 10.92 10.92"
  >
    <g id="copy" transform="translate(-3 -3)">
      <path
        id="Path_398"
        data-name="Path 398"
        d="M17.715,19.47h-5.46A1.755,1.755,0,0,1,10.5,17.715v-5.46A1.755,1.755,0,0,1,12.255,10.5h5.46a1.755,1.755,0,0,1,1.755,1.755v5.46A1.755,1.755,0,0,1,17.715,19.47Z"
        transform="translate(-5.55 -5.55)"
        fill="#e1007f"
      />
      <path
        id="Path_399"
        data-name="Path 399"
        d="M6.12,4.17h5.75A1.758,1.758,0,0,0,10.215,3H4.755A1.755,1.755,0,0,0,3,4.755v5.46A1.758,1.758,0,0,0,4.17,11.87V6.12A1.95,1.95,0,0,1,6.12,4.17Z"
        transform="translate(0)"
        fill="#e1007f"
      />
    </g>
  </svg>
);
